<template>
  <BasicPagination
    :current-page
    :nb-pages
    :nb-pages-max
    :nb-results="habilitations?.length ?? 0"
    @change="(value) => (currentPage = value)"
  />
  <div class="rattachements--desktop">
    <div
      v-if="habilitations"
      class="cardLayoutWrapper cardLayoutWrapper--header"
    >
      <div class="elem elem--span-8">
        <span>{{ headerFirstCol }}</span>
      </div>
      <div class="elem elem--span-5"><span>Contrat d’apprentissage</span></div>
      <div class="elem elem--span-5"><span>Contrat de professionnalisation</span></div>
      <div class="elem elem--span-5"><span>Contrat PRO-A</span></div>
      <div class="elem elem--span-5"><span>Action de formation</span></div>
      <div class="elem elem--center elem--span-2"><span>Facture</span></div>
      <div class="elem elem--center elem--span-2"><span>RIB</span></div>
      <div class="elem elem--center elem--span-2"><span>Admin</span></div>
      <div class="elem elem--center elem--span-2"></div>
    </div>
    <div
      class="gridElemWrapper cardLayoutWrapper"
      v-for="vm in pageVMs"
      :key="vm.id"
    >
      <div class="elem elem--span-8">
        <div class="card__top">
          <BasicIcon :name="vm.display.icon" />
          <div class="card__top__text">
            <BasicLink
              v-if="allowNavigate && vm.display.linkParam"
              class="link"
              :label="vm.display.title"
              @link-click="navigateTo(vm.display.linkRoute, vm.display.linkParam)"
            />
            <BasicText v-else>
              {{ vm.display.title }}
            </BasicText>
            <BasicText
              class="sous-titre"
              :style="{ fontStyle: vm.display.subtitleMain === 'Utilisateur inconnu' ? 'italic' : undefined }"
            >
              {{ vm.display.subtitleMain }}
            </BasicText>
            <BasicText class="sous-titre">
              {{ vm.siretLabel }}
            </BasicText>
          </div>
        </div>
      </div>
      <template v-if="vm.isMember">
        <BasicCellDropdown
          v-for="tp in DROPDOWN_PERMS"
          :key="tp.key"
          :items="niveauxPermission"
          :model-value="getPermission(vm.raw, tp.key)"
          :readonly="isReadonly"
          @update:model-value="(v) => setPermission(vm.raw, tp.key as TypePermission, v as NiveauPermission)"
          force-value
        />
        <BasicCellActionIcon
          v-for="tg in PERM_TOGGLES"
          :key="tg.label"
          :icon-name="tg.icon"
          :is-readonly
          :deactivated="isDeactivated(vm.raw, tg.label)"
          :disabled="!canToggle(vm.raw, tg.label)"
          :hover-messages="tg.hoverMessages"
          @click="togglePermission(vm.raw, tg.label)"
        />
        <BasicCellActionIcon
          icon-name="trash"
          :is-readonly
          :disabled="isAdminLocal(vm.raw)"
          :hoverMessages="{
            actif: 'Supprimer le rattachement',
            inactif: isAdminLocal(vm.raw)
              ? 'Impossible de supprimer un rattachement d\'un administrateur local'
              : 'Supprimer le rattachement',
          }"
          @click="showDeleteHabilitation(vm.raw)"
        />
      </template>
      <div
        v-else
        style="grid-column-end: none"
        class="flex flex-gap-4"
      >
        <BasicButton
          label="Autoriser"
          :icon-name="engineState.mode === 'entite' ? 'adherent' : 'profile'"
          @click="setActivation(vm.raw, true)"
          :disabled="isReadonly"
        />
        <BasicButton
          label="Refuser"
          icon-name="trash"
          type="danger"
          @click="setActivation(vm.raw, false)"
          :disabled="isReadonly"
        />
      </div>
    </div>
  </div>
  <div class="rattachements--mobile">
    <div
      class="card"
      v-for="vm in pageVMs"
      :key="vm.id"
    >
      <div class="card__top">
        <BasicIcon :name="vm.display.icon" />
        <div class="card__top__text">
          <BasicLink
            v-if="allowNavigate && vm.display.linkParam"
            class="link"
            :label="vm.display.title"
            @link-click="navigateTo(vm.display.linkRoute, vm.display.linkParam)"
          />
          <span v-else>{{ vm.display.title }}</span>
          <template v-if="vm.display.subtitleMain">
            <span
              class="sous-titre"
              :style="{ fontStyle: vm.display.subtitleMain === 'Utilisateur inconnu' ? 'italic' : undefined }"
            >
              {{ vm.display.subtitleMain }}
            </span>
          </template>
          <span class="sous-titre">{{ vm.siretLabel }}</span>
        </div>
      </div>
      <template v-if="vm.isMember">
        <div class="card__section">
          <WrapperDropdown
            v-for="tp in DROPDOWN_PERMS"
            :key="tp.key"
            :items="niveauxPermission"
            :model-value="getPermission(vm.raw, tp.key)"
            @update:model-value="(v) => setPermission(vm.raw, tp.key as TypePermission, v as NiveauPermission)"
            :readonly="isReadonly"
            force-value
          />
        </div>
        <div class="card__bottom">
          <div
            v-for="tg in PERM_TOGGLES"
            :key="tg.label"
            class="elem"
          >
            <span>{{ tg.label }} :</span>
            <BasicCellActionIcon
              :icon-name="tg.icon"
              :is-readonly
              :deactivated="isDeactivated(vm.raw, tg.label)"
              :disabled="!canToggle(vm.raw, tg.label)"
              :hover-messages="tg.hoverMessages"
              @click="togglePermission(vm.raw, tg.label)"
            />
          </div>
          <div class="elem">
            <span>Supprimer le rattachement :</span>
            <BasicCellActionIcon
              icon-name="trash"
              :is-readonly
              :disabled="isAdminLocal(vm.raw)"
              :hoverMessages="{
                actif: 'Supprimer le rattachement',
                inactif: isAdminLocal(vm.raw)
                  ? 'Impossible de supprimer un rattachement d\'un administrateur local'
                  : 'Supprimer le rattachement',
              }"
              @click="showDeleteHabilitation(vm.raw)"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="card__section">
          <BasicText class="elem">La demande de rattachement est en attente d'autorisation.</BasicText>
        </div>
        <div class="card__bottom">
          <div class="elem flex justify-content-space-between align-self-stretch">
            <BasicButton
              label="Autoriser"
              :icon-name="engineState.mode === 'entite' ? 'adherent' : 'profile'"
              @click="setActivation(vm.raw, true)"
              :disabled="isReadonly"
            />
            <BasicButton
              label="Refuser"
              icon-name="trash"
              type="danger"
              @click="setActivation(vm.raw, false)"
              :disabled="isReadonly"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { type HabilitationsAdminEmits } from './HabilitationsAdmin.type'
  import { objectToDropdownItems } from '@/features/interface/shared/tools'
  import { NiveauPermission, NiveauPermissionLibelle, TypePermission } from '@/features/domaine/types/opco'
  import { storeToRefs } from 'pinia'
  import { useHabilitationsAdminContentStore } from './useHabilitationsAdminContentStore'
  import type { HabilitationDTO } from '@/features/api/habilitation/dto/habilitation'
  import { useDialog } from '@/features/interface/dialog'
  import { useHabilitationsPermissions } from './useHabilitationsPermissions'
  import BasicCellDropdown from '@designSystem/components/basic/cell/BasicCellDropdown.vue'
  import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'
  import { useHabilitationsAdminListState, type ModeHabilitation } from './useHabilitationsAdminListState'

  const emits = defineEmits<Pick<HabilitationsAdminEmits, 'autorisationsChanged'>>()

  const niveauxPermission = objectToDropdownItems(NiveauPermissionLibelle)

  const storeContent = useHabilitationsAdminContentStore()
  const { deleteHabilitation, setHabilitationMembre, navigateTo } = storeContent
  const { habilitations, engineState, isReadonly, allowNavigate } = storeToRefs(storeContent)

  const { currentPage, nbPages, pageVMs, headerFirstCol, nbPagesMax, DROPDOWN_PERMS, PERM_TOGGLES } =
    useHabilitationsAdminListState({
      habilitations,
      mode: computed(() => engineState.value.mode as ModeHabilitation),
    })

  const { getPermission, setPermission, togglePermission, isDeactivated, canToggle, isAdminLocal } =
    useHabilitationsPermissions()

  const setActivation = async (habilitation: HabilitationDTO, estAccepté: boolean) => {
    if (isReadonly.value) return
    const dialog = useDialog()
    const title = estAccepté ? 'Confirmer le rattachement' : 'Confirmer la suppression'
    const reponse = await dialog.showDialog({ title, message: '', closable: true, type: 'YesNo' })
    if (reponse !== 'Yes') return

    if (estAccepté) {
      try {
        await setHabilitationMembre(habilitation)
        emits('autorisationsChanged', 'Update', habilitation)
      } catch {}
    } else {
      try {
        await deleteHabilitation(habilitation)
        emits('autorisationsChanged', 'Delete', habilitation)
      } catch {}
    }
  }

  const showDeleteHabilitation = async (habilitation: HabilitationDTO) => {
    if (isReadonly.value) return
    const dialog = useDialog()
    const reponse = await dialog.showDialog({
      message: ['Confirmez-vous la suppression du rattachement ?', '', 'Attention, cette opération est définitive.'],
      type: 'OkCancel',
      closable: true,
      title: 'Suppression rattachement',
    })
    if (reponse === 'Ok') {
      try {
        await deleteHabilitation(habilitation)
        emits('autorisationsChanged', 'Delete', habilitation)
      } catch {}
    }
  }
</script>

<style lang="less">
  @import '../index.less';
</style>

<style scoped lang="less">
  @import '../rattachements/Rattachements.less';

  .link :deep(.text) {
    font-weight: bolder;
  }
</style>
